export default "__VITE_ASSET__CyEPboG9__"